<div class="popup" >
    <div class="container-detalles panelDetailLocations" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches && !isLoading)}">
        <loading [isLoading]="isLoading"></loading>

        <div *ngIf="!mobileQuery.matches" class="btnClose">
            <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="CancelButton()"></mat-icon>
        </div>

        <div *ngIf="!mobileQuery.matches" class="arrow-container">
            <mat-icon *ngIf="!fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_down</mat-icon>
        </div>
        <div class="details-flex" #scrollContainer>
            <form [formGroup]="detailsForm" class="edit-form-wrapper">

            <!-- Primera sección -->
            <div class="header_panel">

                <div class="btnReturn" (click)="CancelButton()" matTooltip="Regresar">
                    <mat-icon>arrow_back_ios</mat-icon>
                </div>

                <!-- Encabezado -->
                <div class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
                    <img [src]="(category.panelIcon || category.icon) | findUrl" class="header-img" />

                    <!-- VIN-->
                    <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
                        <label class="subtitlePanel">Nuevo {{ category.shortName }}</label>

                        <label class="vin-title-container">
                            <input class="vin-title-input" [ngClass]="{'input-error': detailsForm.get('identifier').invalid && detailsForm.get('identifier').touched}" formControlName="identifier" type="text" placeholder="Identificador" />
                        </label>
                        <label *ngIf="detailsForm.get('identifier').invalid && detailsForm.get('identifier').touched" class="field-error">Este campo es necesario</label>

                    </div>
                </div>

            </div>

            <div class="data-section-container">
                <div class="text-header">
                    <h3>Datos Generales</h3>
                </div>

                <div *ngIf="isSelectingLocation" class="selecting-banner" (click)="stopSelecting()">
                    Presiona un punto en el mapa para ubicar las coordenadas. Presiona aquí para Cancelar
                </div>

                <div *ngIf="!isSelectingLocation && locationMarker != null" class="selected-banner">
                    Puedes mover el marcador en el mapa para editar las coordenadas. Presiona el botón de abajo para seleccionar un nuevo punto.
                </div>

                <div class="row-data">
                    <div class="">
                        <label class="titlePanel">*Coordenada X</label>
                    </div>
                    <div class="">
                        <input class="general-data coords-input" [ngClass]="{'input-error': detailsForm.get('cordsX').invalid && detailsForm.get('cordsX').touched}" formControlName="cordsX" type="text" readonly placeholder="Presiona para ubicar en el mapa" (click)="selectOnMap()" />
                    </div>
                    <label *ngIf="detailsForm.get('cordsX').invalid && detailsForm.get('cordsX').touched" class="field-error">Selecciona un punto en el mapa</label>
                </div>

                <div class="row-data">
                    <div class="">
                        <label class="titlePanel">*Coordenada Y</label>
                    </div>
                    <div class="">
                        <input class="general-data coords-input" [ngClass]="{'input-error': detailsForm.get('cordsY').invalid && detailsForm.get('cordsY').touched}" formControlName="cordsY" type="text" readonly placeholder="Presiona para ubicar en el mapa" (click)="selectOnMap()" />
                    </div>
                    <label *ngIf="detailsForm.get('cordsY').invalid && detailsForm.get('cordsY').touched" class="field-error">Selecciona un punto en el mapa</label>
                </div>

                <div class="row-data" *ngIf="statusOptions.length > 0">
                    <div class="">
                        <label class="titlePanel">Estatus</label>
                    </div>
                    <div class="">
                        <select class="general-data" [ngClass]="{'input-error': detailsForm.get('status').invalid && detailsForm.get('status').touched}" formControlName="status">
                            <option [ngValue]="null" disabled>Selecciona una opcion</option>
                            <option *ngFor="let option of statusOptions" [ngValue]="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>
                    <label *ngIf="detailsForm.get('status').invalid && detailsForm.get('status').touched" class="field-error">Selecciona un estatus</label>
                </div>
            </div>

            <!-- seccion de ttabs -->
            <div class="tab-group">
                <div class="tab-content-wrapper">

                    <!-- Primera sección datos del activo-->
                    <div class="data-section-container">
                        <div class="text-header">
                            <h3>Datos de la Ubicacion</h3>
                        </div>

                        <div formArrayName="dataValues">
                            <div *ngFor="let data of dataFields; let i = index" [formGroupName]="i">
                                <div *ngIf="isNewDataField(i) || getNameVisibility(data.key)" class="row-data" [ngClass]="{'row-data-new': isNewDataField(i)}">
                                    <div class="">
                                        <label *ngIf="!isNewDataField(i)" class="titlePanel">{{ getUsableName(data.key) }}</label>
                                        <input *ngIf="isNewDataField(i)" class="titlePanel-input" [ngClass]="{'input-error': isDuplicateKey(i) || isEmptyKey(i)}" formControlName="key" type="text" placeholder="Nombre del campo" />
                                        <label *ngIf="isNewDataField(i) && isDuplicateKey(i)" class="field-error">Este nombre ya existe</label>
                                        <label *ngIf="isNewDataField(i) && isEmptyKey(i) && !isDuplicateKey(i)" class="field-error">Este campo es necesario</label>
                                    </div>
                                    <div class="">
                                        <input class="general-data" formControlName="value" type="text" />
                                    </div>
                                    <button *ngIf="isNewDataField(i)" type="button" class="remove-data-btn" (click)="removeDataField(i)" matTooltip="Eliminar">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="row-data add-data-row">
                            <button type="button" class="add-data-btn" (click)="addNewDataField()" matTooltip="Agregar dato">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="data-section-container actions-container">
                        <button type="button" class="btnCancel" mat-raised-button (click)="CancelButton()">Cancelar</button>
                        <button type="button" class="btnSave" mat-raised-button [disabled]="hasDuplicateKeys() || hasEmptyNewKeys() || detailsForm.get('identifier').invalid || detailsForm.get('cordsX').invalid || detailsForm.get('cordsY').invalid || isLoading" (click)="CreateButton()">Crear</button>
                    </div>
                </div>
            </div>
            </form>
        </div>

    </div>
</div>
